/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import { TableCell, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { createListStyles } from '../../RegistryWidgets/Common/ListStyles';
import { TableTooltip } from '../../StyledComponents/TableTooltip';
import { checkStringValueAndTranslate, checkValue, DATA_UNAVAILABLE } from '../../../utils/utils';
import {
    DelayedDownloadingsListItemDto,
    DelayedDownloadingStatus,
    LazyLoadingErrorTypes,
} from '../../../data/api/downloadings/downloadingsClient.typings';
import { useTranslation } from 'react-i18next';
import { COLOR_BY_DELAYED_DOWNLOADINGS_ITEM_STATUS } from '../DelayedDownloadingsConfig';
import { theme } from '../../../assets/style/them';

interface CustomStatusCellProps {
    item: DelayedDownloadingsListItemDto;
}

export const CustomStatusCell = (props: CustomStatusCellProps) => {
    const ListStyles = makeStyles((theme: Theme) => createStyles(createListStyles(theme)));
    const classes = ListStyles();
    const { t } = useTranslation();
    const { item } = props;

    const getCellTextClasses = (value: unknown): string => {
        let classNames = `${classes.tableBodyText} ${classes.boldText}`;

        if (value === DATA_UNAVAILABLE) {
            classNames += ` ${classes.unavailableValue}`;
            return classNames;
        }

        return classNames;
    };

    const getStatusColorAndTranslate = (status: DelayedDownloadingStatus) => {
        let color: string;
        let text: string;

        if (COLOR_BY_DELAYED_DOWNLOADINGS_ITEM_STATUS.hasOwnProperty(status)) {
            color = COLOR_BY_DELAYED_DOWNLOADINGS_ITEM_STATUS[status];
            text = checkStringValueAndTranslate(status, 'downloadings.downloadingStatuses.', t).toLocaleUpperCase();
        } else {
            color = theme.palette.error.main;
            text = checkValue(status);
        }
        return { color, text };
    };

    const { text, color } = getStatusColorAndTranslate(item.status);

    return (
        <TableTooltip
            title={
                LazyLoadingErrorTypes[item.errorMessage]
                    ? checkStringValueAndTranslate(item.errorMessage, 'downloadings.downloadingErrors.', t)
                    : ''
            }
            placement="top"
        >
            <TableCell align={'left'} className={classes.middleCell}>
                <Typography className={getCellTextClasses(item.status)} style={{ color: color }}>
                    {text}
                </Typography>
            </TableCell>
        </TableTooltip>
    );
};
